var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-multiselect',{attrs:{"label":"text","track-by":"value","options":_vm.options,"searchable":false,"allow-empty":false},model:{value:(_vm.fieldModelValue),callback:function ($$v) {_vm.fieldModelValue=$$v},expression:"fieldModelValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }